import {Pencil} from 'lucide-react';
import ActionMenu, { ActionMenuItem } from '../shared/action-menu';

interface FolderActionsProps {
  handleEditProperty: () => void;
}

export default function FolderActions({ handleEditProperty }: FolderActionsProps) {
  const actions: ActionMenuItem[] = [
    {
        label: 'Edit',
        icon: <Pencil className="h-4 w-4" />,
        onClick: () => {
        handleEditProperty();
        },
    }, 
  ];

  return (
    <div className="flex z-50">
      <ActionMenu 
        actions={actions} 
        menuClassName="z-[9999]"
      />
    </div>
  );
}
